import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { startWith, map } from 'rxjs/operators';
import { CommSummaryModel } from '../../models/commissionsummary/commsummary.model';
import { CommissionSummaryService } from '../../service/commission-summary.service';
import { GlobalService } from 'src/app/service/global.service';
import { HomeModel } from 'src/app/models/home/home.model';
import { HomeService } from 'src/app/service/home.service';

@Component({
  selector: 'app-search-comm-plan',
  templateUrl: './review-commissions-search.component.html',
  styleUrls: ['./review-commissions-search.component.css']
})
export class ReviewCommissionsSearchComponent implements OnInit {

  public commSummaryModel = new CommSummaryModel();

  private subscriptions: Subscription[] = [];

  dropDownsData: CommSummaryModel[] = [];
  commissionPlansData: CommSummaryModel[] = [];
  filteredSalesChannelsData: CommSummaryModel[] = [];
  filteredCommPlansData: CommSummaryModel[] = [];
  filteredCalendarTypeData: CommSummaryModel[] = [];
  filteredValidToDatesData: CommSummaryModel[] = [];
  getValidToDate: CommSummaryModel[] = [];
  getToDate: CommSummaryModel[] = [];
  effectiveDateData: CommSummaryModel[] = [];
  commplansdata: HomeModel[] = [];
  disputeclosedata: HomeModel[] = [];
  commplansdataFilter: HomeModel[] = [];

  filteredSalesChannelValues: Observable<CommSummaryModel[]> | undefined;
  controlSc = new FormControl();
  filteredCommissionPlans: Observable<CommSummaryModel[]> | undefined;
  controlCp = new FormControl();
  filteredCalendarTypes: Observable<CommSummaryModel[]> | undefined;
  controlCt = new FormControl();
  filteredValidToDates: Observable<CommSummaryModel[]> | undefined;
  controlVtDt = new FormControl();

  searchCriteriaSet = new Set<string>();
  loggedincommplanid: number = 0;

  public effectiveDate: any;

  constructor(private router: Router, private commissionSummaryService: CommissionSummaryService,
    private authGaurdService: AuthGaurdService, private notificationService: NotificationService, private homeService: HomeService, private globalService: GlobalService) {
    globalService._disableBackButton();
  }

  ngOnInit() {
    console.log("Called()");
    this.getCommplansList();

    this.commSummaryModel.salesChannel = localStorage.getItem('sc');
    this.commSummaryModel.commPlanId = localStorage.getItem('commplan');
    this.commSummaryModel.calRunId = localStorage.getItem('calrunid');


  }

  public redirect(url: string, pageName: string) {
    console.log("redirect() Called");

    if (this.commSummaryModel.salesChannel === "null" || this.commSummaryModel.salesChannel === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Sales Channel');
    } else if (this.commSummaryModel.commPlanId === "null" || this.commSummaryModel.commPlanId === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Commission Plan');
    } else if (this.commSummaryModel.calRunId === "null" || this.commSummaryModel.calRunId === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Payroll End Date');
    } else {



      localStorage.setItem('sc', this.commSummaryModel.salesChannel);
      localStorage.setItem('country', this.commSummaryModel.country ?? '');
      localStorage.setItem('commplan', this.commSummaryModel.commPlanId);
      localStorage.setItem('calrunid', this.commSummaryModel.calRunId);

      // this.commSummaryModel.extra_sc_emp_id = 1;
      // this.commSummaryModel.sc_emp_id = "NA";
      // this.commSummaryModel.sup_extra_sc_emp_id = 1;
      // this.commSummaryModel.sup_sc_emp_id = "NA";

      // Set parameters based on user role
      const userRole = localStorage.getItem('CURRENT_USERROLE_SESSION');

      this.commSummaryModel.userRole = userRole;

      if (userRole === "Sales Channel Admin") {
        // Sales Channel Admin view ALL employees in channel (like Admin but filtered)
        this.commSummaryModel.extra_sc_emp_id = 1;
        this.commSummaryModel.sc_emp_id = "NA";
        this.commSummaryModel.sup_extra_sc_emp_id = 1;
        this.commSummaryModel.sup_sc_emp_id = "NA";
      } else {
        // Default Admin behavior
        this.commSummaryModel.extra_sc_emp_id = 1;
        this.commSummaryModel.sc_emp_id = "NA";
        this.commSummaryModel.sup_extra_sc_emp_id = 1;
        this.commSummaryModel.sup_sc_emp_id = "NA";
      }


      this.commissionSummaryService.commSummaryModel = this.commSummaryModel;
      this.commissionSummaryService.searchCriteriaSet = this.searchCriteriaSet;

      console.log(localStorage.getItem('validToDt'));

      this.getEffectiveDate(this.commSummaryModel.commPlanId, url, pageName);
      this.getDisputeStatus();
    }
  }

  getCommplansList() {
    console.log("getCommplansList() Called");

    this.homeService.getCommplansList(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'), localStorage.getItem('CURRENT_USERROLE_SESSION'))
      .subscribe((data: any) => {
        this.commplansdata = data;
        console.log(this.commplansdata);
        this.commplansdataFilter = JSON.parse(JSON.stringify(data));

        if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN" || localStorage.getItem('CURRENT_USERROLE_SESSION') === "Admin") {
          this.getDropDownsData();
        } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Channel Admin") {
          // Sales Channel Admin uses same approach as Admin but with Retail filtering
          this.getSalesChannelAdminDropdowns();
        } else {
          this.getUserDropDownsData();
        }

        if (data.length > 0) {

          for (let val of this.commplansdata) {
            this.loggedincommplanid = val.comm_plan_id;
          }

        }
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  public getSalesChannelAdminDropdowns(): void {
    console.log("getSalesChannelAdminDropdowns() Called - Using Sales Channel Admin endpoint");
    console.log("Employee ID:", localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'));

    this.subscriptions.push(
      this.commissionSummaryService.getSalesChannelAdminDropDownsData(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION')).subscribe(
        (response: CommSummaryModel[]) => {
          console.log("Response from getSalesChannelAdminDropDownsData:", response);
          this.dropDownsData = response;

          // Get unique sales channels from user's assigned commission plans
          this.filteredSalesChannelsData = this.dropDownsData.filter((v, i) =>
            this.dropDownsData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i);
          this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => (a.salesChannel < b.salesChannel) ? -1 : 1);

          console.log("Filtered Sales Channels:", this.filteredSalesChannelsData);

          this.filteredCommPlansData = this.dropDownsData.filter((v, i) =>
            this.dropDownsData.findIndex(item => item.commPlan == v.commPlan) === i);
          this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

          this.filteredValidToDatesData = this.dropDownsData.filter((v, i) =>
            this.dropDownsData.findIndex(item => item.validFromDt == v.validFromDt) === i);

          if (localStorage.getItem('calrunid')) {
            console.log("Inside IF");
            const filterValue = this.globalService._normalizeValue(localStorage.getItem('calrunid'));
            this.getValidToDate = this.filteredValidToDatesData.filter(item =>
              this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getValidToDate = this.getValidToDate.filter((v, i) =>
              this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
            this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);

            this.getToDate = this.filteredValidToDatesData.filter(item =>
              this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getToDate = this.getToDate.filter((v, i) =>
              this.getToDate.findIndex(item => item.validToDt == v.validToDt) === i);
            this.getToDate = this.getToDate.sort((a, b) => (a.validToDt < b.validToDt) ? -1 : 1);

            localStorage.setItem('calrunid', this.commSummaryModel.calRunId);

            if (this.getValidToDate.length > 0 && this.getToDate.length > 0) {
              console.log(JSON.stringify(this.getValidToDate[0].validFromDt));
              localStorage.setItem('validToDt', JSON.parse(JSON.stringify(this.getValidToDate[0].validFromDt)));
              localStorage.setItem('validLevelToDt', JSON.parse(JSON.stringify(this.getToDate[0].validToDt)));
              localStorage.setItem('level', "0");
            }
          }

          this.loadDefaults();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          console.error("Error fetching dropdown data:", msg);
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }


  public getDropDownsData(): void {
    console.log("getDropDownsData Called");
    this.subscriptions.push(
      this.commissionSummaryService.getDropDownsData().subscribe(
        (response: CommSummaryModel[]) => {
          this.dropDownsData = response;

          //console.log(JSON.stringify(this.dropDownsData));

          this.filteredSalesChannelsData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i);
          this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => (a.salesChannel < b.salesChannel) ? -1 : 1);

          this.filteredCommPlansData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.commPlan == v.commPlan) === i);
          this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

          this.filteredValidToDatesData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.calRunId == v.calRunId) === i);

          console.log(JSON.stringify(localStorage.getItem('calrunid')));

          if (localStorage.getItem('calrunid')) {
            console.log("Inside IF");
            const filterValue = this.globalService._normalizeValue(localStorage.getItem('calrunid'));
            this.getValidToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getValidToDate = this.getValidToDate.filter((v, i) => this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
            this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);

            this.getToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getToDate = this.getToDate.filter((v, i) => this.getToDate.findIndex(item => item.validToDt == v.validToDt) === i);
            this.getToDate = this.getToDate.sort((a, b) => (a.validToDt < b.validToDt) ? -1 : 1);

            localStorage.setItem('calrunid', this.commSummaryModel.calRunId);

            console.log(JSON.stringify(this.getValidToDate[0].validFromDt));

            localStorage.setItem('validToDt', JSON.parse(JSON.stringify(this.getValidToDate[0].validFromDt)));
            localStorage.setItem('validLevelToDt', JSON.parse(JSON.stringify(this.getToDate[0].validToDt)));
            localStorage.setItem('level', "0");
          }
          this.loadDefaults();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getUserDropDownsData(): void {
    console.log("getUserDropDownsData() Called");
    this.subscriptions.push(
      this.commissionSummaryService.getUserDropDownsData(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION')).subscribe(
        (response: CommSummaryModel[]) => {
          this.dropDownsData = response;

          this.filteredSalesChannelsData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i);
          this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => (a.salesChannel < b.salesChannel) ? -1 : 1);

          this.filteredCommPlansData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.commPlan == v.commPlan) === i);
          this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

          this.filteredValidToDatesData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.validFromDt == v.validFromDt) === i);

          if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {

            const filterValue1 = this._normalizeValue(this.loggedincommplanid.toString());
            this.filteredCommPlansData = this.filteredCommPlansData.filter(item => this._normalizeValue(item.commPlanId) === filterValue1);

            this.filteredValidToDatesData = this.filteredValidToDatesData.filter(item => this._normalizeValue(item.issalesrepaccess).startsWith("y"));
          }

          if (localStorage.getItem('calrunid')) {
            // if (localStorage.getItem('calrunid').length > 0) {
            const filterValue = this.globalService._normalizeValue(localStorage.getItem('calrunid'));
            this.getValidToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getValidToDate = this.getValidToDate.filter((v, i) => this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
            this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);

            this.getToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getToDate = this.getToDate.filter((v, i) => this.getToDate.findIndex(item => item.validToDt == v.validToDt) === i);
            this.getToDate = this.getToDate.sort((a, b) => (a.validToDt < b.validToDt) ? -1 : 1);

            localStorage.setItem('calrunid', this.commSummaryModel.calRunId);

            console.log(JSON.stringify(this.getValidToDate[0].validFromDt));

            localStorage.setItem('validToDt', JSON.parse(JSON.stringify(this.getValidToDate[0].validFromDt)));
            localStorage.setItem('validLevelToDt', JSON.parse(JSON.stringify(this.getToDate[0].validToDt)));
            localStorage.setItem('level', "0");
          }

          this.loadDefaults();

        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public loadDefaults() {
    this.commSummaryModel.salesChannel = localStorage.getItem('sc');
    this.commSummaryModel.commPlanId = localStorage.getItem('commplan');
    this.commSummaryModel.calRunId = localStorage.getItem('calrunid');

    this.getDefaults(this.commSummaryModel.salesChannel, this.commSummaryModel.commPlanId);
  }

  public getDefaults(event: any, commissionPlanId: any) {
    console.log("getDefaults() Called");
    const filterValue = this._normalizeValue(event);
    this.commissionPlansData = this.dropDownsData.filter(item => this._normalizeValue(item.salesChannel).startsWith(filterValue));

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
    //  const filterValue1 = this._normalizeValue(this.loggedincommplanid.toString());
      const filterValue1 = this._normalizeValue(commissionPlanId.toString());
    
    
      this.commissionPlansData = this.commissionPlansData.filter(item => this._normalizeValue(item.commPlanId) === filterValue1);
    }

    this.commissionPlansData = this.commissionPlansData.filter((v, i) => this.commissionPlansData.findIndex(item => item.commPlan == v.commPlan) === i);
    this.commissionPlansData = this.commissionPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN" || localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Channel Admin") {
      this.filteredValidToDatesData = this.dropDownsData.filter(item => item.commPlanId == commissionPlanId);
    }

  }

  public getSelectedSc(event: any) {
    console.log("getSelectedSc() Called");

    //this.commSummaryModel.salesChannel = null;
    this.commSummaryModel.commPlanId = null;
    this.commSummaryModel.calRunId = null;


    const filterValue = this._normalizeValue(event.target.value);
    console.log(filterValue);
    this.commissionPlansData = this.dropDownsData.filter(item => this._normalizeValue(item.salesChannel).startsWith(filterValue));
    console.log(this.commissionPlansData);

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
      console.log(this.loggedincommplanid);
     // const filterValue1 = this._normalizeValue(this.loggedincommplanid.toString());
      //this.commissionPlansData = this.commissionPlansData.filter(item => this._normalizeValue(item.commPlanId) === filterValue1);
      console.log(this.commissionPlansData);
    }

    this.commissionPlansData = this.commissionPlansData.filter((v, i) => this.commissionPlansData.findIndex(item => item.commPlan == v.commPlan) === i);
    this.commissionPlansData = this.commissionPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

    console.log(this.commissionPlansData);
  }

  public getSelectedCommPlan(event: any) {
    console.log("getSelectedCommPlan() Called");
    this.commSummaryModel.calRunId = null;


    const filterValue = this._normalizeValue(event.target.value);
    console.log(filterValue);
    if (this.commplansdataFilter.length > 0) {
      this.commplansdataFilter = this.commplansdata.filter(item => this._normalizeValue(item.comm_plan_id.toString()) === filterValue);
      localStorage.setItem('CURRENT_SC_EMP_ID_SESSION', this.commplansdataFilter[0].scempid);
    }
    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN" || localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Channel Admin") {
      this.filteredValidToDatesData = this.dropDownsData.filter(item => item.commPlanId == filterValue);
      this.filteredValidToDatesData = this.filterPayrollDatesForCurrentMonth(this.filteredValidToDatesData);
      console.log(this.filteredValidToDatesData);
    }
  }

  public getSelectedPayrollCalendar(event: any) {
    console.log("getSelectedPayrollCalendar() Called");
    // if (localStorage.getItem('calrunid')) {
    const filterValue = this.globalService._normalizeValue(event.target.value);
    this.getValidToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
    this.getValidToDate = this.getValidToDate.filter((v, i) => this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
    this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);

    this.getToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
    this.getToDate = this.getToDate.filter((v, i) => this.getToDate.findIndex(item => item.validToDt == v.validToDt) === i);
    this.getToDate = this.getToDate.sort((a, b) => (a.validToDt < b.validToDt) ? -1 : 1);

    localStorage.setItem('calrunid', this.commSummaryModel.calRunId);

    console.log(JSON.stringify(this.getValidToDate[0].validFromDt));
    // }
    localStorage.setItem('validToDt', JSON.parse(JSON.stringify(this.getValidToDate[0].validFromDt)));
    localStorage.setItem('validLevelToDt', JSON.parse(JSON.stringify(this.getToDate[0].validToDt)));
    localStorage.setItem('level', "0");
    // }

  }

  private filterPayrollDatesForCurrentMonth(data: CommSummaryModel[]): CommSummaryModel[] {
    const now = new Date();
    const currentYearMonth = (now.getFullYear() * 100) + (now.getMonth() + 1);
    const filtered = data.filter(item => {
      const calRunId = Number(item.calRunId);
      if (isNaN(calRunId)) {
        return false;
      }
      // Include all past/current payroll months; block future months.
      return calRunId <= currentYearMonth;
    });
    const uniqueByCalRun = filtered.filter((v, i) =>
      filtered.findIndex(item => item.calRunId === v.calRunId) === i
    );
    return uniqueByCalRun.sort((a, b) => Number(b.calRunId) - Number(a.calRunId));
  }

  public getDisputeStatus() {
    console.log("getDisputeStatus() Called");
    this.homeService.getDisputeStatus(this.commSummaryModel.commPlanId, Number(this.commSummaryModel.calRunId))
      .subscribe((data: any) => {
        this.disputeclosedata = data;

        if (this.disputeclosedata.length > 0) {
          if (this.disputeclosedata[0].dispute_close_dt) {
            let d = new Date();
            let d1 = new Date(this.disputeclosedata[0].dispute_close_dt);
            var g1 = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            var g2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());

            if (g1.getTime() < g2.getTime()) {
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
            } else if (g1.getTime() > g2.getTime()) {
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'notvalid');
            } else {
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
            }
          } else {
            localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
          }
        } else {
          localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
        }


      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }



  private getEffectiveDate(commPlanId: number, url: string, pageName: string) {

    const filterValue = this._normalizeValue(commPlanId.toString());
    this.effectiveDateData = this.dropDownsData.filter(item => this._normalizeValue(item.commPlanId).startsWith(filterValue));

    this.effectiveDateData.forEach(jsonModel => {
      this.effectiveDate = jsonModel.effective_date;
    });

    // console.log(this.effectiveDate);

    localStorage.setItem('SESSION_EFFDATE', this.effectiveDate);

    this.router.navigate(['/' + url], { queryParams: { page: pageName } });
  }

  sortByDate(a, b) {
    if (a.validToDt < b.validToDt) {
      return 1;
    }
    if (a.validToDt > b.validToDt) {
      return -1;
    }
    return 0;
  }

  public startCalc(): void {
    const formData = null;
    this.subscriptions.push(
      this.commissionSummaryService.startCalc(formData).subscribe(
        (response: CommSummaryModel[]) => {
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  clearSearchCriteria() {

    localStorage.removeItem('sc');
    localStorage.removeItem('commplan');
    localStorage.removeItem('calrunid');

    this.commSummaryModel.salesChannel = null;
    this.commSummaryModel.commPlanId = null;
    this.commSummaryModel.calRunId = null;

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN" || localStorage.getItem('CURRENT_USERROLE_SESSION') === "Admin") {
      this.getDropDownsData();
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Channel Admin") {
      this.getSalesChannelAdminDropdowns();
    } else {
      this.getUserDropDownsData();
    }
  }

  public redirectPage(url: string) {
    this.router.navigate(['/' + url]);
  }

  private _normalizeValue(value: string): string {
    if (value)
      return value.toString().toLowerCase().replace(/\s/g, '');
    else
      return '';
  }

}
